import { render } from "./add-task-btn.vue?vue&type=template&id=73bed496"
import script from "./add-task-btn.vue?vue&type=script&lang=js"
export * from "./add-task-btn.vue?vue&type=script&lang=js"
script.render = render

export default script